import { DocumentNode, gql } from "@apollo/client";
import {
    baseGraphicElementContent,
    baseKpiReportTemplateContent,
    baseParagraphContent,
    baseReactContent,
    baseWaterProviderTaxonomy
} from "./base";

const GRAPHIC_QUERY = `
        ${baseGraphicElementContent},
        className,
        displayFor,
        graphQLQuery,
        transformationFn,
        visibilityFn,
        type,

        providers {
            ${baseWaterProviderTaxonomy}
        },

        paragraph {
            ${baseParagraphContent},
            className,
            footer {
                value,
                format,
                processed
            },
            text {
                value,
                format,
                processed
            }
        },

        react {
            
            ${baseReactContent},
            className,
            component,
            properties
        },

        kpiReportTemplate {
            ${baseKpiReportTemplateContent}
        }
`;

const GET_GRAPHIC_ELEMENTS = () => {
    return gql`
        query GraphicElements(
            $ids: [Int!],
            $providerAdminIds: [String!]
        ) {
            result: getGraphicElements(
                ids: $ids
                providerAdminIds: $providerAdminIds
            ) { 
                ${GRAPHIC_QUERY}
            }
        }
    `;
};

export const GET_GRAPHIC_ELEMENTS_PARAMS = (
    nids?: number[],
    locationAdminIds?: string[]
): {
    query: DocumentNode;
    options: {
        skip: boolean;
        variables: {
            ids: number[];
            providerAdminIds: string[];
        };
    };
} => {
    const allow =
        !locationAdminIds?.filter(d => d != null && d?.trim() !== "")?.length && !nids?.filter(d => d != null)?.length
            ? false
            : true;

    return {
        query: GET_GRAPHIC_ELEMENTS(),
        options: {
            skip: !allow,
            variables: {
                ids: nids?.filter(d => d != null) ?? [],
                providerAdminIds: locationAdminIds?.filter(d => d != null && d?.trim() !== "") ?? []
            }
        }
    };
};

export const GET_SECOND_PROVIDER_GRAPHIC_ELEMENTS_PARAMS = (
    nids: number[] = [],
    locationAdminId: string
): {
    query: DocumentNode;
    options: {
        skip: boolean;
        variables: {
            ids: number[];
            providerAdminIds: string[];
        };
    };
} => {
    const allow =
        locationAdminId != null && locationAdminId.trim() !== "" && nids?.filter(d => d != null)?.length > 0
            ? true
            : false;

    return {
        query: GET_GRAPHIC_ELEMENTS(),
        // GET_GRAPHIC_ELEMENTS(),
        options: {
            skip: !allow,
            variables: {
                ids: nids?.filter(d => d != null) ?? [],
                providerAdminIds: [locationAdminId]?.filter(d => d != null && d?.trim() !== "") ?? []
            }
        }
    };
};
